import { createFileRoute } from "@tanstack/react-router";
import { loadLegacyContent, LegacyContent, legacyHead } from "@/lib/legacy-content";

export const Route = createFileRoute("/gynecology")({
  loader: () => loadLegacyContent("gynecology"),
  head: ({ loaderData }) =>
    loaderData ? legacyHead("/gynecology", loaderData) : { meta: [{ title: "Gynecology — Healic" }] },
  component: () => <LegacyContent payload={Route.useLoaderData()} />,
});
